"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.swapKeyAndValue = void 0;

/**
 * swap key to value and swap value to key
 * does not mutate object
 * return new object
 * @param {{ [prop: string]: string }} - object that you want to swap
 * @return {[prop:string]: string}
 */
var swapKeyAndValue = function swapKeyAndValue(obj) {
  var newObj = {};

  for (var _prop in obj) {
    newObj[obj[_prop]] = _prop;
  }

  return newObj;
};

exports.swapKeyAndValue = swapKeyAndValue;